import { render, staticRenderFns } from "./MailingExpired.vue?vue&type=template&id=6f11a35e&"
import script from "./MailingExpired.vue?vue&type=script&lang=ts&"
export * from "./MailingExpired.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports